export function contractAddressFromCAIP19(caip19: string): string {
  return caip19.split(":")[2];
}
